// eslint-disable-next-line
import {Modal} from 'bootstrap';
import './parts/language-picker';
import './parts/cookie-consent';
import './parts/register-box';

(() => {
  function labnolThumb(id) {
    return `<img src="https://i.ytimg.com/vi/${id}/hqdefault.jpg"><div class="play"></div>`;
  }

  function labnolIframe() {
    const iframe = document.createElement('iframe');

    iframe.setAttribute('src', `https://www.youtube.com/embed/${this.dataset.id}?autoplay=1`);
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allowfullscreen', '1');

    this.parentNode.replaceChild(iframe, this);
  }

  const youtubePlayers = document.getElementsByClassName('youtube-player');
  for (let i = 0; i < youtubePlayers.length; i += 1) {
    const elementId = youtubePlayers[i].dataset.id;
    const div = document.createElement('div');

    div.setAttribute('data-id', elementId);
    div.innerHTML = labnolThumb(elementId);
    div.onclick = labnolIframe;
    youtubePlayers[i].appendChild(div);
  }

  const selectsWithErrors = document.querySelectorAll('select.has-error');
  for (let i = 0; i < selectsWithErrors.length; i += 1) {
    selectsWithErrors[i].addEventListener('change', (event) => {
      const { value } = event.currentTarget;

      if (value !== 0 || value !== '') {
        event.currentTarget.classList.remove('has-error');
        event.currentTarget.classList.add('has-success');
      }
    });
  }

  const switchButton = document.getElementsByClassName('switch');

  for (let i = 0; i < switchButton.length; i += 1) {
    switchButton[i].addEventListener('click', (event) => {
      const container = event.target.parentNode.parentNode.parentNode;
      container.querySelector('#licenseBox').classList.toggle('register--hidden');
      container.querySelector('#manualBox').classList.toggle('register--hidden');
    });
  }

  const placeholderOptions = document.querySelectorAll('option[value="placeholder"]');
  for (let i = 0; i < placeholderOptions.length; i += 1) {
    placeholderOptions[i].setAttribute('disabled', 'disabled');
  }

  const noopenerLinks = document.querySelectorAll('a[rel="noopener noreferrer"]');
  for (let i = 0; i < noopenerLinks.length; i += 1) {
    noopenerLinks[i].addEventListener('click', (event) => {
      // Create window object with linked location.
      const newWindow = window.open(event.currentTarget.href, '_blank');

      // Remove relation for safety.
      newWindow.opener = null;

      // Stop event bubbling.
      event.preventDefault();
      return false;
    });
  }
})();
